export const COPYRIGHT = `© OOO «Айти Онлайн»`;
